import NotificationSvg from "assets/svgs/NotificationSVG";
import { AddsSvg, CastSvg, ContentSvg, HomeSvg, NotifySvg, SubCatSvg, UsersSvg ,PanelUserSvg,ReciptUserSvg} from "assets/svgs/sidebar";

const menuItems = [
        {
        id : 0 , 
        name : 'Main Menu' ,
        path : '' , 
        onlyText : true ,
    } ,
    {
        id : 1 , 
        name : 'Dashboard' ,
        path : '/app' , 
        icon : HomeSvg ,
        exact : true ,
    } ,
    {
        id : 2 , 
        name : 'Customers' ,
        path : '/app/Customer' , 
        icon : NotifySvg ,
        exact : false ,
    } ,
    {
        id : 3 , 
        name : 'Inventory' ,
        path : '/app/inventory' , 
        icon : AddsSvg ,
        exact : false ,
    } ,
     {
        id : 5 , 
        name : 'Installments' ,
        path : '/app/installments' ,  
        icon : CastSvg ,
        exact : false ,
    } ,


    {
        id : 4 , 
        name : 'Payment/Receipt' ,
        path : '/app/payment' , 
        icon : UsersSvg ,
        exact : false ,
    } ,


      {
        id : 6 , 
        name : 'Provisional Receipt' ,
        path : '/app/provisional-receipt' ,  
        icon : ReciptUserSvg ,
        exact : false ,
    } ,
      {
        id : 6 , 
        name : 'Reports' ,
        path : '/app/reports' ,  
        icon : ReciptUserSvg ,
        exact : false ,
    } ,



    {
        id : 7, 
        name : 'Panel Users' ,
          path: '/app/panel-user',
        icon : PanelUserSvg ,
        exact : false ,
    } ,

    {
        id : 8 , 
        name : 'Notifications' ,
        path : '' , 
        onlyText : true ,
    } ,

     {
        id : 9, 
        name : 'Notifications Templates' ,
          path: '/app/notification-templates',
        icon : NotificationSvg ,
        exact : false ,
    } ,
        {
        id : 10, 
        name : 'Broadcast Campaigns' ,
          path: '/app/broadcast-campaigns',
        icon : NotificationSvg ,
        exact : false ,
     } ,
        {
        id : 11,
        name : 'Notification Logs' ,
          path: '/app/notification-logs',
        icon : NotificationSvg ,
        exact : false ,
     } ,

    {
        id : 12 , 
        name : 'Settings' ,
        path : '' , 
        onlyText : true ,
    } ,
     {
        id : 13 , 
        name : 'GIS Map.' ,
        path : '/app/gis-map' , 
        icon : ContentSvg ,
        exact : false ,
    } ,
    {
        id : 14, 
        name : 'Settings' ,
        path : '/app/settings' , 
        icon : SubCatSvg ,
        exact : false ,
    } ,
   
    // {
    //     id : 8 , 
    //     name : 'Panel Users' ,
    //     path : '/app/admin-users' , 
    //     icon : UsersSvg ,
    //     exact : false ,
    // } ,

]


export default menuItems;